import { Injectable } from '@angular/core';
import { IKBCatalog, IKBCatalogCategory } from '../interfaces/IBase-knowledge-catalog';

@Injectable({
  providedIn: 'root'
})
export class StateOperationsService {

  toggleCategory(category: IKBCatalogCategory): void {
    category.Expanded = !category.Expanded;
  }

  toggleCatalog(catalog: IKBCatalog): void {
    catalog.Expanded = !catalog.Expanded;
  }

  handleToggleSelectAll(status: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    console.log('onToggleSelectAll', event);
  }

  stopPropagation(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
  }
}
